import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/salesContent';
import { SectionShell } from './SectionShell';
export function PainSection() {
  return <SectionShell eyebrow="El punto de partida" title="¿Te suena familiar alguna de estas situaciones?" className="border-t border-gold-500/10 bg-noir-900" data-id="element-180" data-mp="2uy5kyvhd4pwf">
      <div className="mx-auto grid max-w-5xl gap-3 sm:grid-cols-2 sm:gap-4" data-id="element-181" data-mp="2z1lirv564wap">
        {painPoints.map((point, index) => <motion.article key={point.emoji} initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.07,
        ease: [0.22, 1, 0.36, 1]
      }} whileHover={{
        y: -4
      }} className={`flex gap-4 rounded-2xl border border-cream/10 bg-noir-800/70 p-5 transition-colors hover:border-crimson-500/40 sm:p-6 ${index === painPoints.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-182" data-mp="2pysrvszwemle" data-mpi={index}>
            <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-noir-700 text-xl ring-1 ring-cream/10" data-id="element-183" data-mp="3rp3smtb9tvni">
              {point.emoji}
            </span>
            <p className="text-[15px] leading-relaxed text-cream/72" data-id="element-184" data-mp="gg7oegy0agh">{point.text}</p>
          </motion.article>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto mt-8 max-w-3xl rounded-2xl border-l-2 border-crimson-600 bg-noir-800/60 px-5 py-6 text-left sm:mt-12 sm:px-7 sm:py-8" data-id="element-185" data-mp="38x2l72kfkx2h">
        <p className="font-display text-lg font-semibold text-cream sm:text-2xl" data-id="element-186" data-mp="2q59sl999xdva">
          La triste verdad es esta:
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-cream/65 sm:mt-4 sm:text-base" data-id="element-187" data-mp="2l6fayan1lvcr">
          Nadie te enseñó esto en la escuela. No hay clase de "cómo conectar con alguien
          de verdad". Y esa falta de conocimiento te ha costado oportunidades, relaciones
          y momentos que no vuelven.
        </p>
      </motion.div>
    </SectionShell>;
}